export function formatINR(amount) {
  if (amount === null || amount === undefined) return '0';
  const num = Number(amount);
  if (isNaN(num)) return '0';
  return num.toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

export function formatINRFull(amount) {
  if (amount === null || amount === undefined) return '\u20B90';
  return '\u20B9' + formatINR(amount);
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export const LEAD_STATUSES = [
  'NEW', 'INITIAL_QUOTE', 'REVISED_QUOTE', 'FINAL_BID', 'NEGOTIATION', 'WON', 'LOST', 'ON_HOLD', 'CANCELLED', 'OBSOLETE'
];

export const LEAD_CATEGORIES = [
  'CCTV', 'FIRE_ALARM', 'AUTOMATION', 'ACCESS_CONTROL', 'SOLAR', 'EV_CHARGING',
  'UPS', 'PA_SYSTEM', 'SAFETY', 'AI_VISION', 'OTHER'
];

export const PROJECT_STATUSES = ['PLANNING', 'ACTIVE', 'ON_HOLD', 'COMPLETED', 'CANCELLED'];
export const MATERIAL_STATUSES = ['NOT_ORDERED', 'ORDERED', 'PARTIALLY_DELIVERED', 'DELIVERED'];
export const INSTALLATION_STATUSES = ['NOT_STARTED', 'IN_PROGRESS', 'DONE'];
export const EXPENSE_CATEGORIES = ['MATERIAL', 'LABOUR', 'TRANSPORT', 'RENTAL', 'FOOD_STAY', 'TOOLS', 'SUBCONTRACTOR', 'MISC'];
export const OVERHEAD_CATEGORIES = ['SALES_VISIT', 'DIRECTOR_TRAVEL', 'OFFICE', 'SALARY', 'VEHICLE', 'MISC'];
export const PAYMENT_MODES = ['BANK_TRANSFER', 'CASH', 'UPI', 'CHEQUE', 'CREDIT'];
export const REVENUE_PAYMENT_MODES = ['NEFT', 'RTGS', 'CHEQUE', 'CASH', 'UPI'];
export const PAYMENT_STATUSES = ['PAID', 'PENDING', 'PARTIAL'];
export const BOQ_CATEGORIES = ['EQUIPMENT', 'CABLE', 'PASSIVE', 'ACCESSORY', 'SERVICE', 'CIVIL'];

export const STATUS_COLORS = {
  NEW: 'bg-blue-100 text-blue-700',
  INITIAL_QUOTE: 'bg-cyan-100 text-cyan-700',
  REVISED_QUOTE: 'bg-indigo-100 text-indigo-700',
  FINAL_BID: 'bg-purple-100 text-purple-700',
  NEGOTIATION: 'bg-amber-100 text-amber-700',
  WON: 'bg-green-100 text-green-700',
  LOST: 'bg-red-100 text-red-700',
  ON_HOLD: 'bg-gray-100 text-gray-600',
  CANCELLED: 'bg-gray-200 text-gray-500',
  OBSOLETE: 'bg-slate-200 text-slate-500',
  PLANNING: 'bg-blue-100 text-blue-700',
  ACTIVE: 'bg-green-100 text-green-700',
  COMPLETED: 'bg-emerald-100 text-emerald-700',
  PAID: 'bg-green-100 text-green-700',
  PENDING: 'bg-amber-100 text-amber-700',
  PARTIAL: 'bg-orange-100 text-orange-700',
  NOT_ORDERED: 'bg-gray-100 text-gray-600',
  ORDERED: 'bg-blue-100 text-blue-700',
  PARTIALLY_DELIVERED: 'bg-amber-100 text-amber-700',
  DELIVERED: 'bg-green-100 text-green-700',
  NOT_STARTED: 'bg-gray-100 text-gray-600',
  IN_PROGRESS: 'bg-blue-100 text-blue-700',
  DONE: 'bg-green-100 text-green-700',
};

export function getStatusColor(status) {
  return STATUS_COLORS[status] || 'bg-gray-100 text-gray-600';
}

export function formatStatus(status) {
  if (!status) return '';
  return status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
